import { render, staticRenderFns } from "./CustomerServiceChat.vue?vue&type=template&id=73cf13ef&scoped=true"
import script from "./CustomerServiceChat.vue?vue&type=script&lang=js"
export * from "./CustomerServiceChat.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceChat.vue?vue&type=style&index=0&id=73cf13ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cf13ef",
  null
  
)

export default component.exports